import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "how-to-play"
};
const _hoisted_2 = {
  class: "how-to-play__preview",
  "aria-hidden": "true"
};
const _hoisted_3 = {
  class: "how-to-play__title"
};
const _hoisted_4 = {
  class: "how-to-play__desc"
};
const _hoisted_5 = {
  class: "how-to-play__actions"
};
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import AppImage from '@/components/common/AppImage.vue';
import PmDialogShell from '@/components/shell/PmDialogShell.vue';
import newUserGuideStep1 from '@/assets/image/new-user-guide-step-1.png';
import newUserGuideStep2 from '@/assets/image/new-user-guide-step-2.png';
import newUserGuideStep3 from '@/assets/image/new-user-guide-step-3.png';
export default {
  __name: 'HowToPlayTour',
  props: {
    "modelValue": {
      type: Boolean,
      default: false
    },
    "modelModifiers": {}
  },
  emits: /*@__PURE__*/_mergeModels(['get-started'], ["update:modelValue"]),
  setup(__props, {
    emit: __emit
  }) {
    const STEP_KEYS = ['pick', 'trade', 'redeem'];
    const STEP_IMAGES = {
      pick: newUserGuideStep1,
      trade: newUserGuideStep2,
      redeem: newUserGuideStep3
    };
    const open = _useModel(__props, "modelValue");
    const emit = __emit;
    const {
      t
    } = useI18n();
    const stepIndex = ref(0);
    const stepKey = computed(() => STEP_KEYS[stepIndex.value] || STEP_KEYS[0]);
    const stepTitle = computed(() => `${stepIndex.value + 1}. ${t(`howToPlayTour.steps.${stepKey.value}.title`)}`);
    const isLast = computed(() => stepIndex.value >= STEP_KEYS.length - 1);
    const primaryLabel = computed(() => isLast.value ? t('howToPlayTour.getStarted') : t('howToPlayTour.next'));
    function preloadStepImages() {
      if (typeof window === 'undefined') return;
      Object.values(STEP_IMAGES).forEach(src => {
        const img = new Image();
        img.src = src;
      });
    }
    function onVisibleChange(next) {
      open.value = next;
    }
    function onPrimary() {
      if (isLast.value) {
        open.value = false;
        emit('get-started');
        return;
      }
      stepIndex.value += 1;
    }
    watch(open, visible => {
      if (visible) {
        stepIndex.value = 0;
        preloadStepImages();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PmDialogShell, {
        "model-value": open.value,
        "dialog-class": "how-to-play-dialog",
        "sheet-class": "how-to-play-sheet",
        "dialog-width": "400px",
        "show-close": false,
        "show-handle": true,
        "close-on-click-modal": true,
        "destroy-on-close": "",
        "onUpdate:modelValue": onVisibleChange
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(STEP_KEYS, key => {
          return _withDirectives(_createVNode(AppImage, {
            key: key,
            src: STEP_IMAGES[key],
            alt: "",
            class: "how-to-play__image",
            eager: ""
          }, null, 8, ["src"]), [[_vShow, key === stepKey.value]]);
        }), 64))]), _createElementVNode("h2", _hoisted_3, _toDisplayString(stepTitle.value), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)(`howToPlayTour.steps.${stepKey.value}.description`)), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
          type: "button",
          class: "how-to-play__btn",
          onClick: onPrimary
        }, _toDisplayString(primaryLabel.value), 1)])])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};